import React from 'react'
import ClayLayout from "@clayui/layout";
import ClayButton from '@clayui/button';
import "./ComponentHeader.css"

interface ComponentHeaderProps {
    title: string;
    setIsRequestedInfoExpand?: React.Dispatch<React.SetStateAction<boolean>>;
    status?: any
    isQuotationScreen?: boolean
    subheading?: string
    isShowIcon?: boolean
    isArrowIcon: boolean
    isRequestedInfoExpand?: boolean
}

const ComponentHeader: React.FC<ComponentHeaderProps> = ({ title, setIsRequestedInfoExpand, status, isQuotationScreen = false, subheading, isShowIcon = false, isArrowIcon = false, isRequestedInfoExpand = false }) => {

    return (
        <>
            <ClayLayout.Row className="sub-heading-row"
                onClick={() => setIsRequestedInfoExpand && setIsRequestedInfoExpand(prev => !prev)}
                style={{ cursor: "pointer" }}
            >
                <div>
                    {
                        title === 'Send Referral' || title === 'Receive Referral' ? <h2 className='profile-details-subheading mt-0'>{title}</h2> :
                            status === '10' || status === '0' ?
                                <h1 className="disabled-heading  m-0 d-flex align-items-center">
                                    {title}
                                </h1> :
                                <h1 className="header-sub-heading m-0 d-flex align-items-center"
                                    style={{
                                        fontSize: isQuotationScreen ? "20px" : "20px",
                                        fontWeight: "700"
                                    }}
                                >
                                    {title}
                                </h1>}
                    {subheading && (
                        <p className="text-muted m-0" style={{ fontSize: '14px', color: "#949494" }}>
                            {subheading}
                        </p>
                    )}
                </div>
                {
                    (title !== "Partner Services" && isArrowIcon !== false) ? <ClayButton
                        displayType="unstyled"
                    // onClick={() => setIsRequestedInfoExpand && setIsRequestedInfoExpand(prev => !prev)}
                    >
                        {
                            isRequestedInfoExpand ? (
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12.0038 13.9823C11.9138 13.9823 11.831 13.9676 11.7555 13.9381C11.6794 13.9087 11.6052 13.8576 11.533 13.7848L7.87549 10.1281C7.79771 10.0503 7.75605 9.95479 7.75049 9.84145C7.74493 9.72812 7.7866 9.62701 7.87549 9.53812C7.96438 9.44923 8.06271 9.40479 8.17049 9.40479C8.27827 9.40479 8.3766 9.44923 8.46549 9.53812L12.0038 13.0765L15.5422 9.53812C15.6199 9.46034 15.7155 9.41867 15.8288 9.41312C15.9422 9.40756 16.0433 9.44923 16.1322 9.53812C16.221 9.62701 16.2655 9.72534 16.2655 9.83312C16.2655 9.9409 16.221 10.0392 16.1322 10.1281L12.4747 13.7848C12.4024 13.8576 12.3283 13.9087 12.2522 13.9381C12.1766 13.9676 12.0938 13.9823 12.0038 13.9823Z"
                                        fill="#003764"
                                    />
                                </svg>
                            ) : (
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12.0038 9.998C11.9138 9.998 11.831 10.0127 11.7555 10.0422C11.6794 10.0716 11.6052 10.1227 11.533 10.1955L7.87549 13.8522C7.79771 13.93 7.75605 14.0255 7.75049 14.1389C7.74493 14.2522 7.7866 14.3533 7.87549 14.4422C7.96438 14.5311 8.06271 14.5755 8.17049 14.5755C8.27827 14.5755 8.3766 14.5311 8.46549 14.4422L12.0038 10.9038L15.5422 14.4422C15.6199 14.52 15.7155 14.5616 15.8288 14.5672C15.9422 14.5727 16.0433 14.5311 16.1322 14.4422C16.221 14.3533 16.2655 14.255 16.2655 14.1472C16.2655 14.0394 16.221 13.9411 16.1322 13.8522L12.4747 10.1955C12.4024 10.1227 12.3283 10.0716 12.2522 10.0422C12.1766 10.0127 12.0938 9.998 12.0038 9.998Z"
                                        fill="#003764"
                                    />
                                </svg>
                            )
                        }
                    </ClayButton> : null
                }

            </ClayLayout.Row>

        </>
    )
}

export default ComponentHeader